import { CustomDisplayItem } from "@/components/custom/custom-display-item";
import { Box, Typography, styled } from "@mui/material";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const formatDate = (dateObj) => {
  if (!dateObj) return "-";
  if (typeof dateObj === "string") return dateObj;
  const { year, monthValue, dayOfMonth, hour, minute, second } = dateObj;
  return `${year}-${String(monthValue).padStart(2, "0")}-${String(dayOfMonth).padStart(2, "0")} ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}`;
};

const formatBoolean = (val) => {
  if (val === true) return "Yes";
  if (val === false) return "No";
  return "-";
};

export const CustomerProfileActivity = ({ data }) => {
  return (
    <Row>
      <Side>
        <Typography fontWeight={500} fontSize={18}>
          Activity & Dates
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Account activity and audit trail.
        </Typography>
      </Side>
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Created At" value={data?.createdAt} />
        </Box>

        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Updated At" value={data?.updatedAt} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Date of Activation"
            value={formatDate(data?.dateOfActivation)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="First Login Date"
            value={formatDate(data?.firstTimeLoginDate)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Last Password Updated"
            value={formatDate(data?.lastTimePasswordUpdated)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="First Time Login"
            value={formatBoolean(data?.firstTimeLogin)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Welcomed"
            value={formatBoolean(data?.welcomed)}
          />
        </Box>
      </Grid>
    </Row>
  );
};
